import component from './';

/** @type {UICore.ComponentMeta} */
const AbsoluteComponentMeta = {
  id: 'w-absolute',
  name: '绝对定位画布',
  keywords: ['画布', '容器'],
  icon: 'https://vfiles.gtimg.cn/wuji_material/trpc_gateway_test/vgbtx6kqwvg.png',
  category: '布局',
  component,
  propsSchema: {
    type: 'object',
    fields: []
  },
  unpackable: 'default',
  initialLayout: {
    style: {
      height: '160px'
    }
  }
};
export default AbsoluteComponentMeta;
//# sourceMappingURL=meta.js.map
